import { Button, StyledText } from "../../../../components/common";
import { BackIcon, NoticeIcon } from "../../../../components/svgs";
import votingBox from "../../../../components/images/voting_box.png";
import { useTheme, useTrivia } from "../../../../hooks";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useState, useEffect } from "react";
import { SuccessBoxIcon } from "../../../../components/svgs";
import styled from "styled-components";

const ConfirmVoteModal = ({ onBackDropClick, teamName, onVote }) => {
  const [voteSubmittedView, setVoteSubmittedView] = useState(false);

  const { themeContext, theme } = useTheme();

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];
  let history = useHistory();

  const handleSubmission = () => {
    onVote()
      .finally(() =>
        setVoteSubmittedView(true)
      )
  }

  return (
    <>
      <div>
        <div
          style={{
            position: "absolute",
            zIndex: 100,
            top: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.7)",
          }}
          onClick={onBackDropClick}
        ></div>
        <div
          style={{
            position: "absolute",
            zIndex: 100,
            width: "100%",
            bottom: 0,
          }}
        >
          {!voteSubmittedView && (
            <ModalContentContainer>
              <div
                style={{
                  width: 50,
                  height: 8,
                  backgroundColor: "#cbcbcb",
                  borderRadius: 10,
                }}
              />
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                  marginTop: 5,
                  marginBottom: 5,
                }}
              >
                <div onClick={onBackDropClick}>
                  <BackIcon />
                </div>
                <div>
                  <NoticeIcon onClick={() => { }} fill="transparent" />
                </div>
              </div>

              <StyledText style={{ fontSize: 20 }}>Confirm Vote</StyledText>
              <img src={votingBox} alt="voting box" width={100} />
              <StyledText
                style={{
                  textAlign: "center",
                  fontFamily: "MTNRegular",
                  paddingInline: 15,
                }}
              >
                You’re about to vote for team{" "}
                <span style={{ fontFamily: "MTNMedium" }}>{teamName}!</span> in
                the Business Entrepreneurship Challenge. You can only vote once.
              </StyledText>
              <Button
                style={{ backgroundColor: background, width: "80%" }}
                onClick={() => {
                  handleSubmission();
                }}
              >
                <StyledText color="white">Submit vote</StyledText>
              </Button>
            </ModalContentContainer>
          )}
          {voteSubmittedView && (
            <ModalContentContainer>
              <SuccessBoxIcon fill={background} />

              <StyledText>Your vote has been submitted</StyledText>

              <Button
                style={{ backgroundColor: background, width: "60%" }}
                onClick={() => history.push('/business_challenge/poll_page')}
              >
                <StyledText color="white">Ok</StyledText>
              </Button>
            </ModalContentContainer>
          )}
        </div>
      </div>
    </>
  );
};

export default ConfirmVoteModal;

const ModalContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  border-top-right-radius: 15px;
  border-top-left-radius: 15px;
  padding: 20px;
`;
